import React from 'react';
import { toast } from 'react-toastify';

import Checkbox from '@material-ui/core/Checkbox';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import { isArray, includes, isNull, isUndefined } from 'lodash';
import qs from 'querystring';

import { ONLINE } from '~/constants/default';
import { t, number } from '~/helpers';
import api from '~/services/api';

import {
  RECEBIMENTO_READ_ONLY,
  RECEBIMENTO_SELECT_TANKS,
  RECEBIMENTO_WAIT_FINISH,
} from '../Form/constantes';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

export default function TabelaRecebimento({
  idposto,
  idproduto,
  listaDeTanques,
  onAtualizaTanques,
  status,
  onUpdateStatus,
  permitirselecionarmaisdeumtanque,
}) {
  const classes = useStyles();

  const permitirSelecionarMultiplos = permitirselecionarmaisdeumtanque === 'S';

  function alteraValor(
    idtanquefisico,
    altura,
    volume,
    statusLocal,
    tanques,
    valordigitado
  ) {
    for (let idx = 0; idx < tanques.length; idx++) {
      if (statusLocal === RECEBIMENTO_SELECT_TANKS) {
        if (tanques[idx].idtanquefisico === idtanquefisico) {
          tanques[idx].valordigitado = valordigitado;
          tanques[idx].alturainicialdescarganftanque = altura;
          if (volume !== null) {
            tanques[idx].volumeinicialdescarganftanque = volume;
          } else {
            tanques[idx].valordigitado = 0;
          }
          onAtualizaTanques(tanques);
        }
      } else if (statusLocal === RECEBIMENTO_WAIT_FINISH) {
        if (tanques[idx].idtanquefisico === idtanquefisico) {
          tanques[idx].valordigitado = valordigitado;
          tanques[idx].alturafinaldescarganftanque = altura;
          if (volume !== null) {
            tanques[idx].volumefinaldescarganftanque = volume;
          } else {
            tanques[idx].valordigitado = 0;
          }
          onAtualizaTanques(tanques);
        }
      }
    }
  }

  // Load API tanks
  const handleGetAllTanks = React.useCallback(async () => {
    try {
      const params = {
        wherefield: ['idposto', 'idproduto', 'statustanquefisico'],
        valuewherefield: [idposto, idproduto, 'L'],
        typewherefield: ['EQUALS', 'EQUALS', 'EQUALS'],
        orderfield: 'codigotanquefisico',
        ordination: 'asc',
      };

      const { data } = await api.get('estoquestanquespostoscomboios', {
        params,
        paramsSerializer: (param) => qs.stringify(param),
      });

      if (status !== RECEBIMENTO_READ_ONLY) {
        // Percorre os tanques para atualizar os valores
        for (
          let idxServidor = 0;
          idxServidor < data.items.length;
          idxServidor++
        ) {
          for (let idxLocal = 0; idxLocal < listaDeTanques.length; idxLocal++) {
            if (
              listaDeTanques[idxLocal].idtanquefisico ===
              data.items[idxServidor].idtanquefisico
            ) {
              listaDeTanques[idxLocal].statussondatanquefisico =
                data.items[idxServidor].statussondatanquefisico;

              if (listaDeTanques[idxLocal].statussondatanquefisico === ONLINE) {
                if (status === RECEBIMENTO_SELECT_TANKS) {
                  listaDeTanques[idxLocal].alturainicialdescarganftanque =
                    data.items[idxServidor].alturanivel1tanquefisico;
                  listaDeTanques[idxLocal].volumeinicialdescarganftanque =
                    data.items[idxServidor].volume1tanquefisico;
                } else if (status === RECEBIMENTO_WAIT_FINISH) {
                  listaDeTanques[idxLocal].alturafinaldescarganftanque =
                    data.items[idxServidor].alturanivel1tanquefisico;
                  listaDeTanques[idxLocal].volumefinaldescarganftanque =
                    data.items[idxServidor].volume1tanquefisico;
                }
              }

              if (status === RECEBIMENTO_WAIT_FINISH) {
                listaDeTanques[
                  idxLocal
                ].temperaturaambientefimdescarganftanque =
                  data.items[idxServidor].temperaturamediatanquefisico;
              }
            }
          }
        }
        onAtualizaTanques(listaDeTanques);
      }

      // setTanks(data.items);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [listaDeTanques, status]);

  const handleGetDadosArqueacao = React.useCallback(
    async (idtanquefisico, idarqueacao, event, statusLocal, tanques) => {
      try {
        const valorDigitado = event.target.value;

        if (valorDigitado.length > 0) {
          const { data } = await api.get(
            `arqueacoes/${idarqueacao}/${idposto}/${Number(valorDigitado)}`,
            {}
          );

          alteraValor(
            idtanquefisico,
            data.altura,
            data.volume,
            statusLocal,
            tanques,
            1
          );
        } else {
          document.getElementById(`tanque_${idtanquefisico}`).value = '';
          alteraValor(idtanquefisico, 0, 0, statusLocal, tanques, 0);
        }
      } catch (err) {
        document.getElementById(`tanque_${idtanquefisico}`).value = '';
        alteraValor(idtanquefisico, 0, 0, statusLocal, tanques, 0);
        toast.error(t('s.geral.arqueacao.alturanaoexiste'));
      }
    },
    []
  );

  React.useEffect(() => {
    if (status > RECEBIMENTO_READ_ONLY) {
      const intervalId = setInterval(() => {
        handleGetAllTanks();
        onUpdateStatus();
      }, 30000);

      onUpdateStatus();
      handleGetAllTanks();

      return () => clearInterval(intervalId);
    }
    handleGetAllTanks();
  }, [status]);

  // const onSelectTanque = (idtanquefisico, tanques) => {
  //   for (let idx = 0; idx < tanques.length; idx++) {
  //     if (tanques[idx].idtanquefisico === idtanquefisico) {
  //       if (tanques[idx].tanqueselecionado === 1) {
  //         tanques[idx].tanqueselecionado = 0;
  //       } else {
  //         tanques[idx].tanqueselecionado = 1;
  //       }
  //       onAtualizaTanques(tanques);
  //     }
  //   }
  // };

  const onSelectTanque = (idtanquefisico, tanques) => {
    const novosTanques = tanques.map((tanque) => {
      if (tanque.idtanquefisico === idtanquefisico) {
        return {
          ...tanque,
          tanqueselecionado: tanque.tanqueselecionado === 1 ? 0 : 1,
        };
      }

      // Se for seleção única (Radio), desmarca os outros
      if (!permitirSelecionarMultiplos) {
        return { ...tanque, tanqueselecionado: 0 };
      }

      return tanque;
    });

    onAtualizaTanques(novosTanques);
  };

  return (
    <TableContainer component={Paper}>
      {/* {JSON.stringify(permitirSelecionarMultiplos)}
      {JSON.stringify(permitirselecionarmaisdeumtanque)} */}

      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Tanque</TableCell>
            <TableCell align="right">Altura Inicial</TableCell>
            <TableCell align="right">Volume Inicial</TableCell>
            <TableCell align="right">Altura Final</TableCell>
            <TableCell align="right">Volume Final</TableCell>
            <TableCell align="right">Espaço Vazio</TableCell>
            <TableCell align="right">Volume Medido</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {listaDeTanques.map((tanque) => (
            <TableRow key={tanque.codigotanquefisico}>
              {/* <TableCell component="th" scope="row">
                {status === RECEBIMENTO_SELECT_TANKS && (
                  <Checkbox
                    id={`check_${tanque.idtanquefisico}`}
                    checked={tanque.tanqueselecionado === 1}
                    onChange={() =>
                      onSelectTanque(tanque.idtanquefisico, listaDeTanques)
                    }
                  />
                )}
                {tanque.codigotanquefisico}
              </TableCell> */}
              <TableCell component="th" scope="row">
                {status === RECEBIMENTO_SELECT_TANKS &&
                  (permitirSelecionarMultiplos ? (
                    <Checkbox
                      id={`check_${tanque.idtanquefisico}`}
                      checked={tanque.tanqueselecionado === 1}
                      onChange={() =>
                        onSelectTanque(tanque.idtanquefisico, listaDeTanques)
                      }
                    />
                  ) : (
                    <Radio
                      id={`radio_${tanque.idtanquefisico}`}
                      checked={tanque.tanqueselecionado === 1}
                      onChange={() =>
                        onSelectTanque(tanque.idtanquefisico, listaDeTanques)
                      }
                    />
                  ))}
                {tanque.codigotanquefisico}
              </TableCell>
              <TableCell align="right">
                {status === RECEBIMENTO_SELECT_TANKS &&
                tanque.statussondatanquefisico !== ONLINE ? (
                  <TextField
                    type="number"
                    id={`tanque_${tanque.idtanquefisico}`}
                    error={
                      tanque.valordigitado === 0 &&
                      tanque.tanqueselecionado === 1
                    }
                    onKeyUp={(event) => {
                      if (event.key === 'Enter') {
                        handleGetDadosArqueacao(
                          tanque.idtanquefisico,
                          tanque.idarqueacao,
                          event,
                          status,
                          listaDeTanques
                        );
                      }
                    }}
                    onBlur={(event) => {
                      handleGetDadosArqueacao(
                        tanque.idtanquefisico,
                        tanque.idarqueacao,
                        event,
                        status,
                        listaDeTanques
                      );
                    }}
                  />
                ) : (
                  number(tanque.alturainicialdescarganftanque, 0)
                )}
              </TableCell>
              <TableCell align="right">
                {number(tanque.volumeinicialdescarganftanque, 0)}
              </TableCell>
              <TableCell align="right">
                {status === RECEBIMENTO_WAIT_FINISH &&
                tanque.statussondatanquefisico !== ONLINE ? (
                  <TextField
                    type="number"
                    id={`tanque_${tanque.idtanquefisico}`}
                    error={tanque.valordigitado === 0}
                    onKeyUp={(event) => {
                      if (event.key === 'Enter') {
                        handleGetDadosArqueacao(
                          tanque.idtanquefisico,
                          tanque.idarqueacao,
                          event,
                          status,
                          listaDeTanques
                        );
                      }
                    }}
                    onBlur={(event) => {
                      handleGetDadosArqueacao(
                        tanque.idtanquefisico,
                        tanque.idarqueacao,
                        event,
                        status,
                        listaDeTanques
                      );
                    }}
                  />
                ) : (
                  number(tanque.alturafinaldescarganftanque, 0)
                )}
              </TableCell>
              <TableCell align="right">
                {number(tanque.volumefinaldescarganftanque, 0)}
              </TableCell>
              <TableCell align="right">
                {status === RECEBIMENTO_WAIT_FINISH
                  ? number(
                      tanque.capacidadetanquefisico -
                        tanque.volumefinaldescarganftanque,
                      0
                    )
                  : number(
                      tanque.capacidadetanquefisico -
                        tanque.volumeinicialdescarganftanque,
                      0
                    )}
              </TableCell>
              <TableCell align="right">
                {includes(
                  [RECEBIMENTO_WAIT_FINISH, RECEBIMENTO_READ_ONLY],
                  status
                )
                  ? number(
                      tanque.volumefinaldescarganftanque -
                        tanque.volumeinicialdescarganftanque,
                      0
                    )
                  : 0}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
